import { HmrcDataToggleStatusResponse } from '../../api-models';
import { HmrcDataBranch, HmrcDataToggle } from '../../types/core.type';
import { HTTPMethod } from '../../types/enums';
import { AdapterInterface } from '../../types/global';
import BaseAdapter from './baseAdapter';

export default class PostHmrcDataToggle extends BaseAdapter<HmrcDataToggleStatusResponse> implements AdapterInterface {
  rawResponse: HmrcDataToggleStatusResponse;

  async adaptResponse(branch: HmrcDataBranch): Promise<HmrcDataToggle> {
    await this.fetchApiResponse('/api/session/hmrc-data-toggle', HTTPMethod.Post, { branch });
    return {
      isDisplayed: this.rawResponse.is_displayed,
      isEnabled: this.rawResponse.is_enabled,
      branch: this.rawResponse.branch,
      expiresAt: this.rawResponse.expires_at,
    };
  }
}
